import { createPost } from "blog/post"
import { NodeKind } from "blog/json_nodes"

export const TrainingMyCat01 = createPost({
  kind: NodeKind.POST,
  tags: ["cat", "cat training"],
  title: "Training my Cat: Episode 1",
  date: "2020-08-14T:20:00:00.0000Z",
  content: `
    <h1>Started Training my Cat</h1>
    <p>I use a dog clicker and food together</p>
    <p>His first trick was speak because he was already doing it, doing it on demand was a convenient minimal step</p>
    <h2>Clicker</h2>
    <p>Procedure: click, food, repeat</p>
    <h2>Speak</h2>
    <p>Procedure: say speak, click as quickly as I could while he made the sound, feed, repeat</h2>
    <p>Three ~2 minute sessions per day, got it first day by the end of the 3rd day he was doing it consistently without food<p>
  `,
  relatedPosts: [],
  references: [],
  ads: [],
})
